var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highliter',{staticClass:"el-dynamic",attrs:{"value":"Post Title","hide-add":"","hide-right":""}},[_c('h5',{staticClass:"post-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }